module.exports = __webpack_public_path__ + "static/media/Flaticon2.e1e2b6e0.svg";